import * as _ from "lodash";
import * as React from "react";
import styled from "styled-components";
import theme from "styled-theming";
import * as S from "@styled";
import { ThemeType } from "shared/styles/theme";

const DisplayNameColor = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.white,
});

const DisplayNameHoverColor = theme("mode", {
    [ThemeType.light]: S.Colors.purpleDark,
    [ThemeType.dark]: S.Colors.grey_1,
});

const StyledDisplayName = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;

    button {
        border: 0;
        background-color: transparent;
        border-radius: 8px;
        padding: 4px;
        height: fit-content;

        i {
            color: ${DisplayNameColor};
            font-size: var(--header-3-font-size);
            cursor: pointer;
        }
    }
    
    :hover {
        i {
            color: ${DisplayNameHoverColor};
        }
    }
`

export const DisplayName: React.FC<IDisplayNameProps> = ({ displayName, setDisplayName, disabled }) => {
    return (
        <StyledDisplayName>
            <h2>{displayName}</h2>
            <button
                title="Edit display name"
                type="button"
                onClick={setDisplayName}
                disabled={disabled}

            >
                <i className="ci-edit" />
            </button>
        </StyledDisplayName>
    );
};

interface IDisplayNameProps {
    displayName: string | undefined;
    setDisplayName: () => void;
    disabled?: boolean;
}